/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-types */
// import { StickyPosition } from 'vant';
import instance from '../utils/request';
import { Message, MessageRequest } from '../interfaces/Message';
import { User } from '../interfaces/User';
/** 微信第三方登录 */
export const loginAPI = (
    code: unknown
): Promise<{
    code: number;
    msg: string;
    data: {
        userInfo: {
            id: number;
            avatarUrl: string;
            username: string;
            phonenumber: string;
            sex: 1 | 2 | 3; // 1 男 ; 2 女
            age: number;
            personalInfo: string;
            userType: 1 | 2; // 1 病人 ； 2 医生
        };
        Token: string;
    };
}> => instance.post('/user/login', code);
/** 微信第三方登录 */
export const wxloginAPI = (
    code: unknown
): Promise<{
    code: number;
    msg: string;
    data: {
        userInfo: {
            id: number;
            avatarUrl: string;
            username: string;
            phonenumber: string;
            sex: 1 | 2 | 3; // 1 男 ; 2 女
            age: number;
            personalInfo: string;
            userType: 1 | 2; // 1 病人 ； 2 医生
        };
        Token: string;
    };
}> => instance.post('/user/wxlogin', code);
/**
 *
 * @param code
 * @returns
 */
export const loginWithUid = (payload: {
    uid: string;
    passwd: string;
}): Promise<{
    code: number;
    msg: string;
    data: {
        userInfo: {};
        Token: string;
    };
}> => instance.get('/user/test_login', { params: payload });

/** 获取上传文件的临时密钥 */
export const getCosToken = (code: unknown): Promise<any> => instance.post('/common/get_oss_token', code);

/**
 * chat-gpt
 */
export const chatGPTID = (payload: {
    question: string;
    chat_id: number;
}): Promise<{
    code: number;
    data: number;
    msg: string;
}> => instance.post('/chat/question_id', payload);

// 拉取chatgpt历史记录
export const fetchHistory = (payload: {
    chat_id:number;
    limit: number;
}): Promise<{
    code: number;
    msg: string;
    data: {
        chat_history_list:Message[] | null;
    }
}> =>
    instance.get(`/chat/chat_history?`, { params: payload });

export const sendMessage = (payload: MessageRequest): Promise<{
    code: number;
    msg: string;
    data: {};
}> => instance.post('/chat/send_message', payload);

export const createNewChat = (): Promise<{
    code: number;
    msg: string;
    data: {
        chat_id: number;
    };
}> =>
    instance.post('/chat/create');

export const getChatList = (payload:{
    user_id: number;
}): Promise<{
    code: number;
    msg: string;
    data: {
        chat_list: Array<{
            chat_id: number;
            title: string;
        }>;
    };
}> => instance.get(`/chat/chat_list`, { params: payload });

export const deleteChatHistory = (payload: {
    chat_id: number;
}): Promise<{
    code: number;
    msg: string;
    data: {};
}> => instance.post(`/chat/delete`, payload);

export const getAllUsers = (): Promise<{
    code: number;
    msg: string;
    data: User[]
}> => instance.get(`/user/all_user`);

export const editAiMessage = (payload: {
    chat_id: number;
    message_id: number;
    content: string;
}): Promise<{
    code: number;
    msg: string;
    data: {};
}> => instance.post(`/admin/change_chatmessage`, payload);
